import { FormulaParser } from '@datapolarna/formulaparser';
import { createLanguage, type FormulaLanguageDescription } from './formulaLanguage';

export const formulaParser = new FormulaParser();
formulaParser.addDefaultFunctions();

const languageDescription: FormulaLanguageDescription = {
  variables: [
    {
      name: 'carrying',
      details: 'Boolean',
      info: 'Whether the vehicle is carrying at least one package',
    },
    {
      name: 'carriedCount',
      details: 'Number',
      info: 'Number of packages currently carried by the vehicle',
    },
    {
      name: 'packageCapacity',
      details: 'Number',
      info: 'Maximum number of packages the vehicle can carry',
    },
  ],
};

export const language = createLanguage(formulaParser, languageDescription);
